import React, { useEffect, useState } from 'react';

// Antd
import {
    WhatsAppOutlined,
    SearchOutlined,
    BookOutlined,
    FilterOutlined,
} from '@ant-design/icons';
import {
    Input,
    Select,
    Spin,
    Tag,
    Empty,
    Badge,
} from 'antd';
import { Link } from 'react-router-dom';

// API
import { getUsersCourses } from '../../../Constants/Api/functions/function';

// Redux
import { useSelector } from 'react-redux';

// Styles
import './style.scss';

import { DEFAULT_USER_PROFILE_IMAGE } from '../../../Constants/Api/azure/azure';

const MyCources = () => {
    const [isLoading, setIsLoading] = useState(false);
    const userProfile = useSelector(state => state.userProfile.userProfile);
    const [userCources, setUserCources] = useState();
    const [data, setData] = useState();
    const [allCources, setAllCources] = useState();
    const [coursesData, setCoursesData] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [activeTag, setActiveTag] = useState('All');

    useEffect(() => {
        if (data) {
            const sortedData = [...data].sort((a, b) => {
                return a?.orderNumber - b?.orderNumber;
            });

            setCoursesData(
                sortedData.map((item) => {
                    return {
                        id: item?.id,
                        title: item?.name,
                        discription: item?.description,
                        isPublished: item?.isPublished,
                        thumbnail: item?.coverImage,
                        price: item?.price,
                        authorName: item?.createdBy?.name,
                        authorImage: item?.createdBy?.profileImage,
                        orderNumber: item?.orderNumber,
                        whatsappGroupLink: item?.whatsappGroupLink,
                        tags: item?.tags,
                    };
                })
            );
        }
    }, [data]);

    useEffect(() => {
        if (userProfile?.role !== 'superadmin') {
            handleGetUserCources();
        }
    }, []);

    const handleGetUserCources = async () => {
        setIsLoading(true)
        try {
            const userCources = await getUsersCourses(userProfile?.id)
            setData(userCources)
            setUserCources(userCources)
            setAllCources(userCources)
        } catch (error) {
            console.error('handleGetUserCources', error)
        }
        setIsLoading(false)
    }

    const handleSearch = (value) => {
        setSearchValue(value);
        if (value) {
            const filteredData = allCources?.filter((item) => {
                return item?.name?.toLowerCase().includes(value.toLowerCase());
            });
            setData(filteredData);
        } else {
            setData(allCources);
        }
    }

    const filterBytags = (value) => {
        setActiveTag(value);
        if (value === 'All') {
            setData(allCources);
        } else {
            const filteredData = allCources?.filter((item) => {
                const tagsArray = item?.tags?.split(',');
                return tagsArray?.find((tag) => tag === value);
            });
            setData(filteredData);
        }
    }

    const getTagLabel = (tag) => {
        const tagMap = {
            'VideoTutorials': 'Video Tutorials',
            'Exams': 'Exams',
            'TrainingAndCourses': 'Training & Courses',
            'News': 'News',
            'Seminar': 'Seminar',
        };
        return tagMap[tag] || tag;
    }

    const getTagColor = (tag) => {
        const colorMap = {
            'VideoTutorials': '#6366f1',
            'Exams': '#f59e0b',
            'TrainingAndCourses': '#10b981',
            'News': '#3b82f6',
            'Seminar': '#8b5cf6',
        };
        return colorMap[tag] || '#6366f1';
    }

    const renderTags = (tags) => {
        if (!tags) return null;
        return tags.split(',').map((tag, index) => (
            <span key={index} className="mc-tag" style={{ '--tag-color': getTagColor(tag) }}>
                {getTagLabel(tag)}
            </span>
        ));
    }

    const isEnrolled = (courseId) => {
        return userCources?.find((course) => course?.id === courseId);
    }

    return (
        <div className='my-courses-page'>
            {/* Header Section */}
            <div className='mc-header'>
                <div className='mc-header-left'>
                    <div className='mc-header-icon'>
                        <BookOutlined />
                    </div>
                    <div>
                        <h1 className='mc-title'>My Courses</h1>
                        <p className='mc-subtitle'>
                            {coursesData?.length || 0} course{coursesData?.length !== 1 ? 's' : ''} available
                        </p>
                    </div>
                </div>
                <div className='mc-header-right'>
                    <div className='mc-search-wrapper'>
                        <Input
                            prefix={<SearchOutlined style={{ color: '#9ca3af' }} />}
                            placeholder="Search courses..."
                            size="large"
                            allowClear
                            value={searchValue}
                            onChange={(e) => handleSearch(e.target.value)}
                            className='mc-search-input'
                        />
                    </div>
                    <Select
                        placeholder="Filter"
                        suffixIcon={<FilterOutlined />}
                        value={activeTag}
                        onChange={(value) => filterBytags(value)}
                        className='mc-filter-select'
                        size="large"
                    >
                        <Select.Option value='All'>All Categories</Select.Option>
                        <Select.Option value='VideoTutorials'>Video Tutorials</Select.Option>
                        <Select.Option value='Exams'>Exams</Select.Option>
                        <Select.Option value='TrainingAndCourses'>Training & Courses</Select.Option>
                        <Select.Option value='News'>News</Select.Option>
                        <Select.Option value='Seminar'>Seminar</Select.Option>
                    </Select>
                </div>
            </div>

            {/* Course Grid */}
            <Spin spinning={isLoading} tip="Loading courses..." size="large">
                {coursesData?.length === 0 && !isLoading ? (
                    <div className='mc-empty-state'>
                        <Empty
                            description={
                                <span className='mc-empty-text'>
                                    {searchValue ? 'No courses match your search' : 'No courses enrolled yet'}
                                </span>
                            }
                        />
                    </div>
                ) : (
                    <div className='mc-grid'>
                        {coursesData?.map((item, index) => (
                            <div
                                className='mc-card'
                                key={item.id}
                                style={{ animationDelay: `${index * 0.05}s` }}
                            >
                                <Link to={`/dashboard/cources/${item.id}`} className='mc-card-link'>
                                    {/* Image */}
                                    <div className='mc-card-image'>
                                        <img
                                            src={
                                                item?.thumbnail
                                                    ? item?.thumbnail
                                                    : require('./1695793881259.jpeg')
                                            }
                                            alt={item?.title}
                                        />
                                        <div className='mc-card-overlay'>
                                            <Badge
                                                status={item?.isPublished ? 'success' : 'error'}
                                                text={
                                                    <span className='mc-status-text'>
                                                        {item?.isPublished ? 'Published' : 'Unpublished'}
                                                    </span>
                                                }
                                                className='mc-status-badge'
                                            />
                                        </div>
                                        {item?.price === 0 && (
                                            <span className='mc-free-badge'>FREE</span>
                                        )}
                                    </div>

                                    {/* Content */}
                                    <div className='mc-card-content'>
                                        {/* Tags */}
                                        <div className='mc-tags-row'>
                                            {renderTags(item?.tags)}
                                        </div>

                                        {/* Title */}
                                        <h3 className='mc-card-title'>{item?.title}</h3>

                                        {/* Author & Price Row */}
                                        <div className='mc-card-meta'>
                                            <div className='mc-author'>
                                                <img
                                                    src={
                                                        item?.authorImage
                                                            ? item?.authorImage
                                                            : DEFAULT_USER_PROFILE_IMAGE
                                                    }
                                                    alt={item?.authorName}
                                                    className='mc-author-avatar'
                                                />
                                                <span className='mc-author-name'>{item?.authorName}</span>
                                            </div>
                                            {item?.price > 0 && (
                                                <span className='mc-price'>{item?.price} LKR</span>
                                            )}
                                        </div>
                                    </div>
                                </Link>

                                {/* Actions */}
                                <div className='mc-card-actions'>
                                    <Link
                                        to={`/dashboard/cources/${item.id}`}
                                        className={`mc-action-btn mc-action-primary ${isEnrolled(item.id) ? 'enrolled' : ''}`}
                                    >
                                        {userProfile?.role !== 'superadmin'
                                            ? (isEnrolled(item.id) ? 'Continue Learning' : 'Enroll Now')
                                            : 'View Course'
                                        }
                                    </Link>
                                    {item?.whatsappGroupLink && (
                                        <a
                                            href={item?.whatsappGroupLink}
                                            target='_blank'
                                            rel="noreferrer"
                                            className='mc-action-btn mc-action-whatsapp'
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            <WhatsAppOutlined />
                                        </a>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </Spin>
        </div>
    );
};
export default MyCources;